import _ from 'lodash';
import getHistory from 'globalHistory';
import qs from 'querystring';
import { FLYOUT_URL_KEY } from './flyout';

export const SAVED_VIEWS_KEY = 'savedView';

const parseQuery = query => {
  let splitPattern;
  if (_.startsWith(query, `?${FLYOUT_URL_KEY}`)) {
    splitPattern = `?${FLYOUT_URL_KEY}`;
  } else {
    splitPattern = `&${FLYOUT_URL_KEY}`;
  }

  const pathWithoutFlyout = _.first(_.split(query, splitPattern));

  return qs.parse(_.replace(pathWithoutFlyout, '?', ''));
};

const getFlyoutQueryString = query => {
  let splitPattern;
  if (_.startsWith(query, `?${FLYOUT_URL_KEY}`)) {
    splitPattern = `?${FLYOUT_URL_KEY}`;
  } else {
    splitPattern = `&${FLYOUT_URL_KEY}`;
  }

  const splittedPath = _.split(query, splitPattern);

  if (_.size(splittedPath) > 1) {
    return `flyout${_.last(splittedPath)}`;
  }

  return null;
};

/**
 * @param {Object} query
 * @param {Object} filters
 */
export const getPossibleFilterKeys = (query, filters) => {
  const filterKeys = _.keys(filters);
  const queryKeys = _.keys(query);
  return _.intersection(filterKeys, queryKeys);
};

/**
 * @param {Object} query
 * @param {Object} filters
 */
export const areActiveFilters = (query, filters) => {
  const newQuery = _.isString(query) ? parseQuery(query) : query;
  return !_.isEmpty(getPossibleFilterKeys(newQuery, filters));
};

/**
 * @param {Object} query
 * @param {Object} filters
 */
export const getFiltersToUpdate = (query, filters) => {
  const newQuery = _.isString(query) ? parseQuery(query) : query;

  const filterKeys = getPossibleFilterKeys(newQuery, filters);
  const filtersToUpdate = _.pick(newQuery, filterKeys);
  _.forEach(filtersToUpdate, (filter, filterKey) => {
    filtersToUpdate[filterKey] = _.map(_.split(filtersToUpdate[filterKey], ','), value =>
      !_.isNaN(value) && !_.isNaN(parseFloat(value)) ? _.parseInt(value) : value,
    );
  });
  return filtersToUpdate;
};

/**
 * @param {Object} filters
 */
export const changePathByFilters = filters => {
  const { location, search } = getHistory();

  const query = parseQuery(search);

  // Remove all filters
  _.forEach(filters, (filter, filterName) => {
    if (query[filterName]) delete query[filterName];
  });

  const filter = _.pickBy(filters, filterValues => !_.isEmpty(filterValues));

  const newQuery = {
    ...query,
    ...filter,
  };

  getHistory().push({
    ...location,
    search: qs.stringify(newQuery),
  });
};

export const updateFiltersFromUrl = (taskFilterAction, search) => {
  const query = parseQuery(search);

  if (_.keys(query).length > 0) {
    _.each(query, (queryKey, queryTypName) => {
      if (!_.isEqual(FLYOUT_URL_KEY, queryTypName) && !_.isEqual(SAVED_VIEWS_KEY, queryTypName)) {
        _.map(_.split(queryKey, ','), value => {
          const filterValue =
            !_.isNaN(value) && !_.isNaN(parseFloat(value)) ? _.parseInt(value) : value;
          taskFilterAction(queryTypName, filterValue);
        });
      }
    });
  }
};

export const filterTypeName = (filterTyp, value, withRegex) =>
  _.filter(
    _.split(filterTyp, ','),
    type =>
      withRegex
        ? type.toString() !== value.toString().replace(/\s/g, '')
        : type.toString() !== value.toString(),
    [],
  ).join(',');

export const removeFromUrl = (filterName, value, search, pathname) => {
  const query = parseQuery(search);
  const flyoutQueryString = getFlyoutQueryString(search);

  let queryFiltered = [];
  if (value) {
    queryFiltered = filterTypeName(query[filterName], value, true);
  }
  if (queryFiltered.length > 0) {
    query[filterName] = queryFiltered;
  } else {
    delete query[filterName];
  }

  const newSearch = `${qs.stringify(query)}${flyoutQueryString ? `&${flyoutQueryString}` : ''}`;

  getHistory().push({
    search: newSearch,
    pathname,
  });
};

export const changePath = (option, location) => {
  const { search, pathname } = location;
  const flyoutQueryString = getFlyoutQueryString(search);

  const query = parseQuery(search);
  let queryName = query[option.label];

  if (queryName) {
    if (option.value) {
      queryName = `${queryName},${_.toString(option.value)}`;
    } else {
      queryName = filterTypeName(queryName, option.value);
    }
  } else {
    queryName = _.toString(option.value);
  }

  query[option.label] = queryName;

  const newSearch = `${qs.stringify(query)}${flyoutQueryString ? `&${flyoutQueryString}` : ''}`;

  getHistory().push({
    search: newSearch,
    pathname,
  });
};

export const removeFromUrlByFilters = (filters, query, pathname, viewName) => {
  _.forEach(_.keys(filters), filter => {
    _.forEach(filters[filter], item => {
      removeFromUrl(filter, item, query, pathname);
    });
  });

  if (!_.isEmpty(viewName)) {
    removeFromUrl(SAVED_VIEWS_KEY, null, query, pathname);
  }
};

export const setUrlByFilters = (filters, location) => {
  const { pathname } = location;
  const query = {};
  _.forEach(_.keys(filters), filter => {
    const value = filters[filter];
    if (!_.isEmpty(value)) {
      _.set(query, filter, _.join(value, ','));
    }
  });

  if (!_.isEmpty(query)) {
    getHistory().push({
      search: qs.stringify(query),
      pathname,
    });
  }
};

export default updateFiltersFromUrl;
